























































import Table from '@/components/Table.vue'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { GetTopUpIntegrationPriceDTO } from '@/utils/interfaces/topup.integration.interface'
import {
  getTopUpIntegrationPrices,
  createTopUpIntegrationPrice,
} from '@/api/Topup/topup.integration.api'
import { TableHeader } from '@/utils/interfaces'
import ActionButton from '@/components/ActionButton.vue'
import CardVue from '@/components/Card.vue'
import CreateIntegrationDialog from '@/components/Services/TopUps/CreateIntegrationDialog.vue'
import FlatCard from '~/components/FlatCard.vue'
import TextButton from '~/components/TextButton.vue'
import FlatTable from '~/components/FlatTable.vue'
import TableSwitch from '~/components/TableSwitch.vue'
import ViewFilter from '~/components/ViewFilter.vue'

export default tableHandler<GetTopUpIntegrationPriceDTO>().extend({
  components: {
    appCard: CardVue,
    appTable: Table,
    appActionButton: ActionButton,
    appCreateIntegrationDialog: CreateIntegrationDialog,
    FlatCard,
    TextButton,
    FlatTable,
    TableSwitch,
    ViewFilter,
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('provider'),
          value: 'provider_name',
        },
        {
          text: this.$t('agent'),
          value: 'agent_name',
        },
        {
          text: this.$t('product'),
          value: 'product_name',
        },
        {
          text: this.$t('price'),
          value: 'price',
        },
        {
          text: this.$t('active'),
          value: 'is_active',
        },
        {
          text: this.$t('enable_transfer'),
          value: 'enable_transfer',
        },
        {
          text: this.$t('use-rate'),
          value: 'rate',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader[],
      getIntegrationPrices: getTopUpIntegrationPrices,
      loading: false,
    }
  },
  methods: {
    async onChange(item: GetTopUpIntegrationPriceDTO) {
      try {
        this.loading = true
        await createTopUpIntegrationPrice({
          is_active: item.is_active,
          uuid: item.uuid,
        })
      } catch {
        item.is_active = !item.is_active
      } finally {
        this.loading = false
      }
    },
    toggle: createTopUpIntegrationPrice,
  },
})
